<template>
	<div class="container">
		<mt-header class="header" fixed title="我的电子卡">
			<header-item slot="left" v-bind:isBack=true v-on:onclick="goBack"></header-item>		
		</mt-header>
		<top-list class="topList" :items="tabs" v-on:onIndexChange="onIndexChange">
		</top-list>
		<base-list class="list-wrapper" :items="items" :isMore="isMore" :isLoaded="isLoaded" v-on:loadMore="loadMore">
      <vcard-item 
        v-for="(item, index) in items" 
        :key="index" 
        :item="item">                
      </vcard-item>
    </base-list>
		<empty-item			
			v-if="isLoaded && items.length <= 0"
			title="暂无电子卡"
			:photo="require('../../assets/image/change-icon/empty_red_packet.png')">
		</empty-item>
	</div>
</template>

<script>
import { Header } from 'mint-ui'
import { HeaderItem, TopList, BaseList, EmptyItem } from '../../components/common'
import VcardItem from './child/VcardItem'
import { ENUM } from '../../const/enum'
//import { couponList } from '../../api/coupon'
import { vcardList,vcardAvailable } from '../../api/vcard'
export default {
	components: {
		VcardItem,
	},
	data() {
		return {			
			currentIndex: 0,
			tabs: [
				{
					id: 0,
					title: '未过期'
				},
				{
					id: 1,
					title: '已过期'
        },
			],
			isLoaded: false,
      page: 1,      
      items: [],      
//items:[{"name":"\u5305\u6708\u6d4b\u8bd5\u5361","value":"100.00","card_sn":"RVlYQhFd","effective":1630512000,"expires":1635609600,"status":2},{"name":"\u5305\u6708\u6d4b\u8bd5\u5361","value":"100.00","card_sn":"RVlYQhFc","effective":1630598400,"expires":1632931200,"status":2},{"name":"\u5305\u6708\u6d4b\u8bd5\u5361","value":"100.00","card_sn":"RVlYQhFf","effective":1630684800,"expires":1632931200,"status":2}],
      isMore: 0
		}
	},
	created() {	
		this.loadFirstPageData()	
	},
	methods: {
		goBack() {
			this.$router.go(-1)
		},
		loadFirstPageData() {
      this.loadPageData(true);
    },
    loadMorePageData() {
      this.loadPageData(false);
    },
    loadPageData(isFirstPage) {
      let page = 1
      if (isFirstPage) {
        page = 1        
      } else {
        page = this.page + 1    
      }
      let per_page = 10
			let status = null
			if (this.currentIndex === 0) {
        status = ENUM.VCARD_STATUS.AVAILABLE
      } else if (this.currentIndex === 1) {
        status = ENUM.VCARD_STATUS.EXPIRED
      } 
      /*couponList(page, per_page, status).then(res => {         
        if (res && res.coupons) {          
          if (isFirstPage) {            
            this.items = res.coupons  
          } else {
            this.items = this.items.concat(res.coupons)
          }             
					this.isMore = res.paged.more 
					this.isLoaded = true           
        }
      }, error => {         
      })    */  
      vcardList(page, per_page, status).then(res => {         
        if (res && res.cashgifts) {   
          console.dir(isFirstPage)       
          console.log("status:",status)
          if (isFirstPage) {            
            this.items = res.cashgifts  
            console.log("Items:",this.items)
          } else {
            if(res.cashgifts && res.cashgifts.length>0)this.items = this.items.concat(res.cashgifts)
          }             
					this.isMore = res.paged.more 
					this.isLoaded = true           
        }
      }, error => {         
      })
    },
		onIndexChange(index) {
      this.currentIndex = index
      this.loadFirstPageData()
    },
    loadMore() {  
      if (this.isMore) {
        this.loadMorePageData()
      }          
    }
	},	
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  position: relative;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color: $mainbgColor;	
	height: 100%;  
}
.header {
	@include header;
	border-bottom: 1px solid $lineColor;
}
.topList {
  position: fixed;
  width: 100%;
	margin-top: 44px;	
  height: 40px;		
  z-index: 100;
}
.list-wrapper { 
  margin-top: 92px;
}
</style>




// WEBPACK FOOTER //
// src/page/virtualCard/VirtualCard.vue